import { h, Component, Fragment } from "preact";
import { TicketHeader, TicketBody, EndedTicketPopups } from "../mobile-pages/ticket-ltn.jsx";
import Page from "../../../services/page-data-feed"

import FullSite from "./full-site";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as T from "../desktop-templates/prematch-right-col.jsx";
import * as L from "../desktop-templates/live-general.jsx";
import * as I from "../utils/icons";

import MenuFull from "../desktop-components/menu-full.jsx";
import { MenuSportsOnly } from "../desktop-components/menu-sports-only.jsx";
import MenuTopleagues from "../desktop-components/menu-topleagues.jsx";
import MenuSearchEvent from "../desktop-components/menu-search-event.jsx";
import MenuBetServices from "../desktop-components/menu-bet-services.jsx";
import MenuTimeFilter from "../desktop-components/menu-time-filter.jsx";

import PrematchCarousel from "../desktop-components/prematch-carousel.jsx";

import PrematchLastMinute from "../desktop-components/prematch-last-minute.jsx";
import PrematchLiveEvents from "../desktop-components/prematch-live-events.jsx";
import PrematchTournamentSelector from "../desktop-components/prematch-tournament-selector.jsx";
import PrematchTournament from "../desktop-components/prematch-tournament.jsx";
import PrematchEvent from "../desktop-components/prematch-event.jsx";
import PrematchQuickbet from "../desktop-components/prematch-quickbet.jsx";
import PrematchHomeWidgets from "../desktop-components/prematch-home.jsx";

import PrematchEventsWidget from "../desktop-components/prematch-events-widget.jsx";

import TicketCheckBet from "../desktop-components/ticket-check-bet.jsx";
import TicketLoadBet, { TicketLoadCashier } from "../desktop-components/ticket-load-bet.jsx";
import TicketFastBet from "../desktop-components/ticket-fast-bet.jsx";
import { MarketingEvents } from "../../../utils/gtm-module";
import { PageContent as AwrabetPageContent, HomeContents as AwrabetHomeContents, TournamentsList as AwrabetTournamentsList } from '../../awrabet/desktop-pages/prematch.jsx';
import User from "../../../services/user";
import CasinoService from "../../../services/casino-feed";
import { useState } from "preact/hooks";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Observer from "../utils/observer";
import Config from "../config.jsx";


export default function Prematch() {
	return <FullSite><PrematchTemplate /></FullSite>;
}

export function PrematchTemplate() {
	return <div class="font-roboto">
		<L.TopRowContainer>
			<L.ContainerLink>
				<L.TopPageLink href="/prematch" active={true}>Sport Home</L.TopPageLink>
				<L.TopPageLink href="/live">Live</L.TopPageLink>
			</L.ContainerLink>
		</L.TopRowContainer>
		<div class="flex border-b border-b-harifzinc-950 bg-harif-900 text-white">
			<div class="scrollbar-fancy w-72 flex-none overflow-y-scroll border-r border-r-harifzinc-950">
				<M.MenuRow>
					<M.MenuTitleLabel>Sports Menu</M.MenuTitleLabel>
					<M.MenuCollapseBtnHolder><I.AnglesLeft class="h-4" /></M.MenuCollapseBtnHolder>
				</M.MenuRow>
				<MenuTopleagues callback={item => Page.openTournaments([item.id])} />
				<a class="flex h-8 items-center border-b border-b-harifzinc-950 bg-harifzinc-950 hover:bg-harifzinc-800 text-white" href="/live">
					<M.MenuTitleCenteredLabel><I.StopwatchRegular class="h-3 mr-1" /><span>IN-PLAY</span></M.MenuTitleCenteredLabel>
				</a>
				<MenuTimeFilter />
				<MenuSearchEvent />
				<MenuFull />
				{/*<EsportsMenu /><M.BlankSeparator />*/}
				<MenuBetServices />
			</div>
			<div class="scrollbar-fancy min-w-0 grow overflow-y-scroll border-r border-r-harifzinc-950">
				{/*<PrematchTournamentSelector />*/}
				{/*<PrematchTournament />*/}
				{/*<PrematchEvent />*/}
				<PageContent />
			</div>
			<div class="scrollbar-fancy w-72 flex-none overflow-y-scroll border-r border-r-harifzinc-950">
				<PrematchQuickbet />
				<M.BlankSeparator />
				<T.ColumnTicketWrappper>
					<T.TicketTopRow>
						<TicketHeader />
					</T.TicketTopRow>
					<TicketBody />
					<EndedTicketPopups />
				</T.ColumnTicketWrappper>
				<M.BlankSeparator />
				<TicketLoadBet />
				<M.BlankSeparator />
				<TicketCheckBet />
				{!!User.isAffiliate() && <M.BlankSeparator />}
				<TicketLoadCashier />
				<M.BlankSeparator />
				<EmbeddedMinigame />
			</div>
		</div>
	</div>
}

export class PageContent extends AwrabetPageContent {
	render() {
		const openTournaments = Page.mapTournaments(tournamentInfo => tournamentInfo);
		if (openTournaments.length == 0) {
			return <HomeContents />
		} else {
			return <TournamentsList openTournaments={openTournaments} />
		}
	}
}

export class HomeContents extends AwrabetHomeContents {
	render() {
		return <div>
			<PrematchCarousel />
			{false && <PrematchEventsWidget />}
			<PrematchHomeWidgets />
			{false && <PrematchLiveEvents />}
			{false && <PrematchLastMinute />}
		</div>
	}
}

export class TournamentsList extends AwrabetTournamentsList {
	render({ openTournaments }) {
		return openTournaments.reverse().map(tournamentInfo => (
			<PrematchTournament key={tournamentInfo.tournament.id} tournamentCard={tournamentInfo.card} tournament={tournamentInfo.tournament} />
		))
	}
}

export function EmbeddedMinigame() {
	const [opened, setOpen] = useState(false);
	const logged = User.isLogged() && !User.isAffiliate();

	if (Config.hideHeader || Config.hideFooter)
		return null;

	const handleOpen = () => {
		if (logged) {
			setOpen(true)
		} else {
			Observer.notify('open-user-signup');
		}
	}

	if (!opened || !logged)
		return <div class="w-full h-100 flex items-center justify-center bg-[#303030]">
			<div class="w-62.5 h-92.5 flex items-center justify-center relative cursor-pointer" onClick={handleOpen}>
				<img src={require("url:../assets/img/casino/halloween-preview-blur.png")} class="absolute h-full w-full" />
				<button class="relative z-10 overflow-hidden px-3 py-2 bg-linear-to-r from-purple-600 to-orange-500 text-white font-extrabold text-base uppercase tracking-widest rounded-lg border-2 border-orange-400 shadow-xl hover:-translate-y-1 hover:shadow-orange-500/50 transition-all duration-200 group">
					<div class="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1s_forwards] bg-linear-to-r from-transparent via-white/30 to-transparent skew-x-12"></div>
					<span class="relative flex items-center gap-2 drop-shadow-md">
						<Trans>Play</Trans>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
							<path fill-rule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 20.046c-1.25.687-2.779-.217-2.779-1.643V5.653z" clip-rule="evenodd" />
						</svg>
					</span>
				</button>
			</div>
		</div>
	return <div class="w-full h-100 bg-[#303030]">
		<iframe src={CasinoService.getPlayUrl('Aviator', 'aviator', 'halloween-party-mini')} class="h-full w-full"></iframe>
	</div>
}
